export const ADD = 'ADD'
export const REMOVE = 'REMOVE'

export const initialAlertOptions = {
  bodyId: '',
  heading: '',
  headingId: '',
  kind: 'non-destructive' as const,
  promptValidationKey: '',
  text: '',
}
